// extracted by mini-css-extract-plugin
export default {"container":"TaskInstructionsVideoPlayer-styles-module--container--pQIvj"};